<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" :xxl="{ span: 6 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search... " />
          </li>
          <li>
            <h4>Search Base On</h4>
            <a-radio-group
              @change="handleType"
              buttonStyle="solid"
              v-model="dokumenType"
            >
              <a-radio-button value="Semua">All</a-radio-button>
              <a-radio-button value="Assign">Assignment</a-radio-button>
              <a-radio-button value="Create">Document</a-radio-button>
            </a-radio-group>
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Document Type</label>
                  <a-select
                    placeholder="Ex: SPPD ... "
                    v-model="jenis_dokumen"
                    class="width-full"
                    initialValue="proyek"
                    allowClear
                  >
                    <a-select-option value="PD">SPPD</a-select-option>
                    <a-select-option value="PS">SPPS</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">PD Schedule</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalBuat">Created Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="tgl_buat"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Project ... "
                    v-model="kategori"
                    class="width-full"
                    initialValue="proyek"
                    allowClear
                  >
                    <a-select-option value="Project">Project</a-select-option>
                    <a-select-option value="Non Project"
                      >Non Project</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option value="delivered"
                      >Delivered</a-select-option
                    >
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process"
                      >On Process</a-select-option
                    >
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }" :xxl="{ span: 18 }">
      <DataList
        :loading="loading"
        title="SPPD/S List"
        createLink="createSppd"
        manifestLink="manifest"
        editLink="edit"
        :dataList="sppdSearch"
        :isTransactional="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "sppd",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      sppdList: [],
      basedList: [],
      search: "",
      kategori: undefined,
      status: undefined,
      transactionDt: [],
      tgl_buat: [],
      dokumenType: "Semua",
      jenis_dokumen: undefined,
    };
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
    this.fetchData();
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
    ]),
    sppdSearch() {
      let self = this;

      let output = _.chain(this.sppdList)
        .groupBy("title")
        .map((value) => value[0])
        .value();

      if (this.dokumenType === "Semua") {
        output = _.chain(this.sppdList)
          .groupBy("title")
          .map((value) => value[0])
          .value();
      } else if (this.dokumenType === "Assign") {
        output = _.filter(output, {
          tipe: self.dokumenType,
        });
      } else {
        output = _.filter(output, { tipe: self.dokumenType });
      }

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            moment(obj.tgl_sppd)
              .format(this.getDefaultDateFormat)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (
              moment(obj.tgl_mulai).format(this.getDefaultDateFormat) +
              " - " +
              moment(obj.tgl_selesai).format(this.getDefaultDateFormat)
            )
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        output = _.filter(output, { peruntukan: self.kategori });
      }

      if (this.jenis_dokumen) {
        output = _.filter(output, {
          jenis_surat: self.jenis_dokumen,
        });
      }

      if (this.status) {
        output = _.filter(output, (item) => {
          return item.status.toLowerCase() == self.status.toLowerCase();
        });
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );

        output = _.filter(output, (obj) => {
          return obj.tgl_mulai >= startDt && obj.tgl_selesai <= endDt;
        });
      }

      if (self.tgl_buat.length > 0) {
        let startDt = moment(this.tgl_buat[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(this.tgl_buat[1]).format(this.getStandartFormatDate);
        output = _.filter(output, (obj) => {
          return obj.tgl_sppd >= startDt && obj.tgl_sppd <= endDt;
        });
      }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "sppds",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.basedList = response.data.data;

          response.data.data.forEach((data) => {
            let status = "";
            if (data.tipe === "Assign") {
              status = "Assigne";
            } else {
              status = data.status;
            }
            const date =
              moment(data.tgl_mulai).format(this.getDefaultDateFormat) +
              " - " +
              moment(data.tgl_selesai).format(this.getDefaultDateFormat);

            this.sppdList.push({
              title: data.no_sppd,
              subtitle: data.allocation + " | " + data.kode_project,
              subdesc: [{ deskripsi: data.deskripsi},
              "Est. Cost : " + (data.est_cost ? this.formatCurrency('IDR',data.est_cost).replace(",00", "") : this.formatCurrency('IDR',0).replace(",00", "")),
              date],
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              status: status,
              id: data.id_sppd,
              user_pembuat: data.user_pembuat,
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : null
                : null,
              closeStatus: data.close_sts=='1' ? 'Close' : null,
              canceled_Status: data.canceled_sts=="false" ? "Canceled" : "",
              tipe: data.tipe,
              peruntukan: data.peruntukan,
              jenis_surat: data.jenis_surat,
              tgl_mulai: data.tgl_mulai,
              tgl_selesai: data.tgl_selesai,
              tgl_sppd: data.tgl_sppd,
              searchQ:
                data.no_sppd + " " + data.allocation + " " + data.deskripsi,
              status_direktorat:{
                direktorat: data.direktorat,
                status: data.status_keuangan
              }
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!error.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    handleType() {},
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "sppds",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          //this.fetchData();
          this.$router.go();
          this.searching;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style lang="less">
.ant-list-item {
  &-action {
    background-color: whitesmoke;
    padding: 5px 0;
  }
}
</style>
